export default "__VITE_ASSET__B75E3fYP__"